import { render, staticRenderFns } from "./NumberSelector.vue?vue&type=template&id=0ad31bea&scoped=true&"
import script from "./NumberSelector.vue?vue&type=script&lang=js&"
export * from "./NumberSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad31bea",
  null
  
)

export default component.exports